import { FC, MouseEventHandler } from "react";
import {
  Dialog,
  DialogProps,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { Button, Form } from "react-admin";

export interface DialogFormProps {
  open: DialogProps["open"];
  loading?: boolean;
  onCancel: MouseEventHandler;
  onSubmit: (data: unknown) => void;
  submitLabel?: string;
  cancelLabel?: string;
  children: React.ReactNode;
}

export const DialogForm: FC<DialogFormProps> = ({
  open,
  loading,
  onCancel,
  cancelLabel = "Cancelar",
  submitLabel = "Confirmar",
  children,
  onSubmit,
}) => (
  <Dialog open={open}>
    <Form onSubmit={onSubmit}>
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        <Button label={cancelLabel} onClick={onCancel} disabled={loading} />
        <Button label={submitLabel} type="submit" disabled={loading} />
      </DialogActions>
    </Form>
  </Dialog>
);
